import Hamb from "../../../../../assets/images/png/Hamb.webp";
import ProgrammeImage1 from "../../../../../assets/images/png/courses/international/programme1.webp";
import SchoolImage from "../../../../../assets/images/png/school/international/white-woman.webp";

export const dataSchoolDataEurope = {
  tag: "Data",
  id: "dataSchool",
  url: "/data-school",
  image: SchoolImage,

  name: "Data School",
  description: `The Utiva data school is designed to help data enthusiasts kickstart their journey to 
  learning analytics and data strategy, as well as helping 
  profesionals advance in the data space. `,
  keywords: `Data science, Data science course, Data analytics, Data school, data science training, Python, PowerBI, Excel`,
  metatags: `Data science courses in Nigeria. Become a data analyst in 1 months through our learning program. Learn Python, PowerBI, Excel to prepare you for the future of work.`,
  courses: [
    {
      id: 1,
      courseImage: ProgrammeImage1,
      courseName: "Data Science Bootcamp",
      courseDescription: `
      Become a full stack data scientist and be ready to work with some of the top companies in Europe, US, and Canada. Learn to analyze data, build data models etc to help companies make informed decision.
    `,
      courseStartDate: "December 2, 2023",

      courseDuration: "6 Months",

      courseTags: ["For Data Enthusiasts", "For Early Professionals"],

      courseUrl: "/data-science-bootcamp",

      enrolUrl: "https://learn.utiva.io/enroll/2063587?price_id=2792241",

      bookCallUrl:
        "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1PA4tqYlKUaUAr3aLVwwLAHZsmUOixiPZvAEfvCvOvOD3TnyicP2mHeo8HGW9tSrmaHbyso32h",
      chatWithUsUrl: "https://wa.me/447951258895",
    },
  ],

  testimony: {
    testimonierImage: Hamb,
    testimonierName: "Mayowa Hambolu",
    testimonierTitle: "Data Analyst",
    testimonyDescription: `I went through the Data Analytics Bootcamp and then the ‘Big Data with Python’ program. I am now a Data analyst and Consultant.`,
  },

  article: [],
};
